<template>
  <div class="form-group" :class="[gridClass, { 'form-group-invalid': errors.length }]">
    <div class="relative">
      <select
        v-model="selectedCountry"
        class="form-control z-10 h-14 rounded-lg border-2 px-4 py-2 focus:border-primary/25"
        :class="{ 'is-invalid': errors.length }"
        autocomplete="country"
        autofocus="autofocus"
        name="country"
        @change="handleChange"
      >
        <option value="" :selected="value === ''">Pays de résidence</option>
        <option
          v-for="(name, code) in prioritizedCountries"
          :key="'priority-' + code"
          :value="code"
          :selected="value === code"
        >
          {{ name }}
        </option>
        <option v-if="Object.keys(prioritizedCountries).length" disabled="disabled" value="---------------">
          ---------------
        </option>
        <option v-for="(name, code) in unprioritizedCountries" :key="code" :value="code" :selected="value === code">
          {{ name }}
        </option>
      </select>
    </div>
    <p v-if="errors" class="help-block">
      {{ errors[0] }}
    </p>
  </div>
</template>

<script>
import pick from 'lodash/pick'
import countries from 'i18n-iso-countries'
import countriesI18n from 'i18n-iso-countries/langs/fr.json'

export default {
  name: 'CountrySelect',
  props: {
    value: {
      type: String,
      required: true
    },
    gridClass: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      countries: [],
      selectedCountry: this.value
    }
  },
  computed: {
    prioritizedCountries() {
      return this.$root.countryPriorities.length < 1 ? {} : pick(this.$root.countries, this.$root.countryPriorities)
    },
    unprioritizedCountries() {
      return this.$root.countries
    }
  },
  mounted() {
    countries.registerLocale(countriesI18n)
    this.countries = countries.getNames('fr')
  },
  methods: {
    handleChange() {
      this.$emit('attributeChange', this.selectedCountry)
    }
  }
}
</script>
